module.exports = __webpack_public_path__ + "media/images/flags/32/Isle-of-Man-678fc4aec4f7dec7ba4b539c803fab5d.png";